export const formatBRDate = (val) => {
  if (!val) return '-';
  const s = String(val);
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (m) {
    const [yyyy, mm, dd] = m[1].split('-');
    return `${dd}/${mm}/${yyyy}`;
  }
  try {
    const d = new Date(s);
    if (isNaN(d)) return s;
    const dd = String(d.getUTCDate()).padStart(2, '0');
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const yyyy = d.getUTCFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch { return s; }
};

